"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _commissionBaseDeductionSetting = require("@/api/orderManagement/commissionBaseDeductionSetting");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      dialogVisible: false,
      queryData: {
        taskId: null,
        orderNo: null,
        relationId: null,
        handlerStatus: null,
        page: {
          page: 1,
          size: 10
        }
      },
      total: 0,
      loading: false,
      tableData: []
    };
  },
  methods: {
    open: function open(id) {
      this.queryData.taskId = id;
      this.violatedOrderDetail();
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.queryData = {
        taskId: null,
        orderNo: null,
        relationId: null,
        handlerStatus: null,
        page: {
          page: 1,
          size: 10
        }
      };
      this.dialogVisible = false;
    },
    violatedOrderDetail: function () {
      var _violatedOrderDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loading = true;
              _context.n = 1;
              return (0, _commissionBaseDeductionSetting.violatedOrderDetail)(this.queryData);
            case 1:
              res = _context.v;
              this.loading = false;
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function violatedOrderDetail() {
        return _violatedOrderDetail2.apply(this, arguments);
      }
      return violatedOrderDetail;
    }(),
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.violatedOrderDetail();
    },
    onInitialize: function onInitialize() {
      this.queryData.orderNo = null;
      this.queryData.relationId = null;
      this.queryData.handlerStatus = null;
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.violatedOrderDetail();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.violatedOrderDetail();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.violatedOrderDetail();
    }
  }
};